import React, { useState } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import ArticlesList from './articles-list';
import AuthorsList from './authors-list';
import ScenePage from '../../common/scene/scene-page';

enum TABS {
  ARTICLES,
  AUTHORS,
}

const Articles = () => {
  const { strings } = useStringsContext();
  const [selectedTab, setSelectedTab] = useState(TABS.ARTICLES);

  return (
    <>
      <ScenePage
        title={strings.appBar.articles}
        tabs={[strings.articles.articles, strings.articles.authors]}
        selectedTab={selectedTab}
        onSelectedTab={setSelectedTab}
      >
        {selectedTab === TABS.ARTICLES && <ArticlesList />}
        {selectedTab === TABS.AUTHORS && <AuthorsList />}
      </ScenePage>
    </>
  );
};

export default Articles;
